Whether verification with SEEK Pass should be enabled for this hirer.

- `true`: Enable verification (opt in)
- `false`: Disable verification (opt out)
